var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title is-4" }, [_vm._v("Appointment Scheduler")]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-half" }, [
        _c("p", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filterString,
                expression: "filterString"
              }
            ],
            staticClass: "input is-medium",
            attrs: { placeholder: "Search name or description" },
            domProps: { value: _vm.filterString },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.filterString = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns mt-4" }, [
      _c(
        "div",
        { staticClass: "column is-half" },
        _vm._l(_vm.columnOne, function(suite) {
          return _c("company-card", { key: suite.id, attrs: { suite: suite } })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column is-half" },
        _vm._l(_vm.columnTwo, function(suite) {
          return _c("company-card", { key: suite.id, attrs: { suite: suite } })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6340037c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6340037c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendees/ViewExhibitors.vue
// module id = null
// module chunks = 